module.exports = __webpack_public_path__ + "img/dunaint2.d2d869ec.png";